
import { Box } from "@mui/material";
import { HeaderRupin, ImageRingLoader } from "../../common";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import FooterRupin from "../../common/FooterRupin";
import { ParagraphText, UBButton } from "../../../Libraries";
import { OptionAccountIcon, InvoiceIcon } from "../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const SelectOptionsmodule = ({ selectedOption, setSelectedOption, onContinue }) => {
    const [I18n] = useContext(LanguageContext);
    const navigate = useNavigate();
    const option = [
        {
            id: "invoice",
            icon: <InvoiceIcon />,
            title: I18n.create_and_send_invoices,
            subTitle: I18n.create_send_and_track_invoices_Get_paid_faster,
            route: "/Sales"
        },
        {
            id: "account",
            icon: <OptionAccountIcon />,
            title: I18n.manage_your_accounts,
            subTitle: I18n.track_money_in_and_out_Faster_collections_100reliable,
            route: "/Accounts"
        },
    ]


    return (

        <Grid container className={`row justify-content-center h-100 ${styles.SelectGridContainer}`}>
            <Grid item md={6} className={styles.SelectInnerGrid}>
                <ParagraphText className={"fontSize24 fontWeight500"}>{I18n.what_would_you_like_to_start}</ParagraphText>
                <Box marginBottom={"34px"} />
                {
                    option.map((item, i) => (
                        <Box key={i} id={item?.id} className={`${styles.optionList} ${selectedOption?.id == item?.id ? styles.selected : ""}`} onClick={() => { setSelectedOption(item); triggerLogEvent(analytics, "login_business_type_selected", { option_id: item?.id, option_title: item?.title }); }}>
                            <Box className={styles.iconBox}>
                                {item?.icon}
                            </Box>
                            <Box className={styles.listText}>
                                <ParagraphText className={"fontSize14 newFontColor"}>{item.title}</ParagraphText>
                                <ParagraphText className={"fontSize14 newLightColor"}>{item.subTitle}</ParagraphText>
                            </Box>
                        </Box>))
                }
                <Box className={styles.SelectOptionCTASection}>
                    <UBButton id="onboarding_skip_btn" className="ubSecondaryButton" title={I18n.skip} onClick={(e) => onContinue(e)} />
                    <UBButton id="onboarding_continue_btn" disabled={!(Boolean(selectedOption))} className="ubPrimaryButton" title={I18n.continue} onClick={(e) => onContinue(e)} />
                </Box>
            </Grid>
        </Grid>
    );
};

export default SelectOptionsmodule;
